export const filtersByGroupsScheme = [
  { key: 'statuses' },
  { key: 'selectedSellerAccounts' },
  { key: 'selectedSourceMarketplace' },
  { key: 'timeLeft' },
  { key: 'outOfStockDays' },
  {
    key: 'numberOfOrders',
    childs: [{ key: 'numberOfOrdersFrom' }, { key: 'numberOfOrdersTo' }],
  },
  {
    key: 'numberOfCompetitors',
    childs: [{ key: 'numberOfCompetitorsFrom' }, { key: 'numberOfCompetitorsTo' }],
  },
  {
    key: 'listingDateRange',
    childs: [{ key: 'listDateFrom' }, { key: 'listDateTo' }],
  },
  { key: 'daysWithoutSale' },
  {
    key: 'destinationPriceRange',
    childs: [{ key: 'destinationPriceFrom' }, { key: 'destinationPriceTo' }],
  },
  {
    key: 'profitRange',
    childs: [{ key: 'profitFrom' }, { key: 'profitTo' }],
  },
  {
    key: 'itemViews',
    childs: [{ key: 'itemViewsFrom' }, { key: 'itemViewsTo' }],
  },
  {
    key: 'itemWatchers',
    childs: [{ key: 'itemWatchersFrom' }, { key: 'itemWatchersTo' }],
  },
  { key: 'template' },
  { key: 'notMonitoring' }
];
